// 錢包餘額（新/舊）與賬戶餘額 - 繁體中文
export default {
  common: {
    totalPrefix: "共計",
    totalSuffix: "條數據",
    download: "下載",
    downloadFilename: "數據明細",
    loading: "拼命加載中",
    empty: "暫無數據",
    copySuccess: "複製成功",
  },
  detail: {
    dialogTitle: "餘額明細",
    top: {
      address: "地址：",
      addressBalanceUSDT: "地址總餘額(USDT)：",
    },
    columns: {
      currency: "幣種",
      quantity: "數量",
      balanceUSDT: "餘額(USDT)",
      updateTime: "更新時間",
    },
  },
  newWallet: {
    columns: {
      address: "地址",
      balance: "餘額",
      actions: "操作",
      viewDetails: "查看詳情",
    },
  },
  wallet: {
    columns: {
      currency: "幣種",
      balance: "餘額",
    },
  },
  account: {
    columns: {
      type: "賬戶類型",
      balanceUSDT: "餘額（USDT）",
    },
  },
};
